import {
	SEARCH_HIGHLIGHT_FILTER,
	BUILD_HIGHLIGHT_FILTER,
	TIMELINE_HIGHLIGHT_FILTER,
	VIEWDOCUMENTS_HIGHLIGHT_FILTER,
	SEARCH_CURRENT_TAGS,
	BUILD_CURRENT_TAGS,
	TIMELINE_CURRENT_TAGS,
	VIEWDOCUMENTS_CURRENT_TAGS,
	SEARCH_CURRENT_TAGS_EXCLUDE,
	BUILD_CURRENT_TAGS_EXCLUDE,
	TIMELINE_CURRENT_TAGS_EXCLUDE,
	VIEWDOCUMENTS_CURRENT_TAGS_EXCLUDE,
	CONCEPT_BASED_ON_ID,
	CONCEPT_BASED_ON_ID_SUCCESS,
	CONCEPT_BASED_ON_ID_FAILED,
	RESET_HIGHLIGHT_FILTER,
	SAVE_HIGHLIGHT_STATE,
	UPDATE_ANNOTATION,
} from "../types"

export const searchHighlightFilter = (filter) => ({
	type: SEARCH_HIGHLIGHT_FILTER,
	payload: filter,
})

export const saveHighlightState = (filter) => ({
	type: SAVE_HIGHLIGHT_STATE,
	payload: filter,
})

export const updateSearchHighlight = (filter) => ({
	type: SEARCH_HIGHLIGHT_FILTER,
	payload: filter,
})

export const updateBuildHighlight = (filter) => ({
	type: BUILD_HIGHLIGHT_FILTER,
	payload: filter,
})

export const updateTimelineHighlight = (filter) => ({
	type: TIMELINE_HIGHLIGHT_FILTER,
	payload: filter,
})

export const updateViewDocumentsHighlight = (filter) => ({
	type: VIEWDOCUMENTS_HIGHLIGHT_FILTER,
	payload: filter,
})

/* ********* SAVED TAGS ********* */
export const searchSavedTags = (tags) => ({
	type: SEARCH_CURRENT_TAGS,
	payload: tags,
})

export const updateSearchSavedTags = (tags) => ({
	type: SEARCH_CURRENT_TAGS,
	payload: tags,
})

export const updateBuildSavedTags = (tags) => ({
	type: BUILD_CURRENT_TAGS,
	payload: tags,
})

export const updateTimelineSavedTags = (tags) => ({
	type: TIMELINE_CURRENT_TAGS,
	payload: tags,
})

export const updateViewDocumentsSavedTags = (tags) => ({
	type: VIEWDOCUMENTS_CURRENT_TAGS,
	payload: tags,
})
/* ********* END SAVED TAGS ********* */

/* ********* SAVED TAGS EXCLUDE ********* */
export const searchSavedTagsExclude = (tagsExclude) => ({
	type: SEARCH_CURRENT_TAGS_EXCLUDE,
	payload: tagsExclude,
})

export const updateSearchSavedTagsExclude = (tagsExclude) => ({
	type: SEARCH_CURRENT_TAGS_EXCLUDE,
	payload: tagsExclude,
})

export const updateBuildSavedTagsExclude = (tagsExclude) => ({
	type: BUILD_CURRENT_TAGS_EXCLUDE,
	payload: tagsExclude,
})

export const updateTimelineSavedTagsExclude = (tagsExclude) => ({
	type: TIMELINE_CURRENT_TAGS_EXCLUDE,
	payload: tagsExclude,
})

export const updateViewDocumentsSavedTagsExclude = (tagsExclude) => ({
	type: VIEWDOCUMENTS_CURRENT_TAGS_EXCLUDE,
	payload: tagsExclude,
})
export const getConceptBasedOnId = (id) => ({
	type: CONCEPT_BASED_ON_ID,
	payload: id,
})
export const getConceptBasedOnIdSuccess = (data) => ({
	type: CONCEPT_BASED_ON_ID_SUCCESS,
	payload: data,
})
export const getConceptBasedOnIdFailed = () => ({
	type: CONCEPT_BASED_ON_ID_FAILED,
	payload: {},
})
export const resetHighlightFilter = () => ({
	type: RESET_HIGHLIGHT_FILTER,
	payload: {},
})
export const updateAnnotationStatus = (data) => ({
	type: UPDATE_ANNOTATION,
	payload: data,
})
/* ********* END SAVED TAGS EXCLUDE ********* */
